(function($, duo, undefined) {

	"use strict";

	// classes:
	const CONTAINER_CLASS = 'number-spinner';
	const BUTTON_CONTAINER_CLASS = 'number-spinner__buttons';
	const BUTTON_CLASS = 'number-spinner__button';
	const INPUT_CONTAINER_CLASS = 'number-spinner__input';

	/**
	 * @class NumberSpinner
	 * add extra step-buttons around a number-input
	 */
	class NumberSpinner {

		/**
		 * Creates an instance of NumberSpinner
		 * @param {string} inputSelector css selector for the number input
		 */
		constructor({inputSelector = '.form-number'} = {}) {
			this.inputSelector = inputSelector;

			// setup:
			this._setup();
		} /* constructor */

		/**
		 * Setup HTML markup for the number inputs and attach event listeners
		 */
		_setup() {
			const numberspinner = this;

			// setup markup:
			$(document).find(this.inputSelector).once().each(function(index, element) {
				const $numberInput = $(element);

				// get the input ID:
				let inputId = duo.Utils.uniqueId;
				if($numberInput.attr('id') !== undefined) {
					inputId = $numberInput.attr('id');
				} else {
					$numberInput.attr('id', inputId);
				}

				// make a container block:
				$numberInput.wrap(`<div class="${CONTAINER_CLASS}"></div>`);
				const $container = $numberInput.parent();

				// step:
				// -> we need to get the "step" attribute value from the input
				//    to use on our buttons:
				let byValue = '';
				const stepAttributeValue = $numberInput.attr('step');
				if(duo.Utils.isNumber(stepAttributeValue)) {
					const step = parseFloat(stepAttributeValue);
					byValue = ' ' + Drupal.t('by') + ' ' + step;
				}

				// buttons:
				const buttonZone = $(`<div class="${BUTTON_CONTAINER_CLASS}"></div>`);
				buttonZone.append(`<button type="button" tabindex="-1" class="${BUTTON_CLASS}" data-action="plus" aria-controls="${inputId}">${ Drupal.t(`Increase`) }${byValue}</button>`);
				buttonZone.append(`<button type="button" tabindex="-1" class="${BUTTON_CLASS}" data-action="minus" aria-controls="${inputId}">${ Drupal.t(`Decrease`) }${byValue}</button>`);
				//$container.append(buttonZone);
				$container.append(`<button type="button" tabindex="-1" class="${BUTTON_CLASS}" data-action="plus" aria-controls="${inputId}">${ Drupal.t(`Increase`) }${byValue}</button>`);
				$container.prepend(`<button type="button" tabindex="-1" class="${BUTTON_CLASS}" data-action="minus" aria-controls="${inputId}">${ Drupal.t(`Decrease`) }${byValue}</button>`);

				// input container:
				$numberInput.wrap(`<div class="${INPUT_CONTAINER_CLASS}"></div>`);

				// check state:
				numberspinner._checkState($numberInput);
			});

			// setup event handlers:
			this._setEventHandlers();
		} /* _setup */

		/**
		 * Attach event listeners
		 */
		_setEventHandlers() {
			const numberspinner = this;

			// spinner button click:
			$(document).once().on('click', `.${BUTTON_CLASS}`, function(event) {
				event.preventDefault();
				const $button = $(this);

				// -> get the input:
				const $numberInput = $button.parents(`.${CONTAINER_CLASS}`).find(`.${INPUT_CONTAINER_CLASS} ${numberspinner.inputSelector}`);

				// -> get input-properties:
				// --> step:
				let step = 1;
				const stepAttributeValue = $numberInput.attr('step');
				if(duo.Utils.isNumber(stepAttributeValue)) {
					step = parseFloat(stepAttributeValue);
				}
				// --> min:
				let minValue;
				const minAttributeValue = $numberInput.attr('min');
				if(duo.Utils.isNumber(minAttributeValue)) {
					minValue = parseFloat(minAttributeValue);
				}
				// --> max:
				let maxValue;
				const maxAttributeValue = $numberInput.attr('max');
				if(duo.Utils.isNumber(maxAttributeValue)) {
					maxValue = parseFloat(maxAttributeValue);
				}
				// --> input value:
				let currentNumber = 1;
				const inputValue = $numberInput.val();
				if(duo.Utils.isNumber(inputValue)) {
					currentNumber = parseFloat(inputValue);
				}

				// -> variable for the new number:
				let newNumber = currentNumber;

				// -> calculate the new value and put it in the input:
				switch($button.data('action')) {
					case 'plus':
						newNumber = currentNumber + step;
						if(maxValue !== undefined) {
							if(newNumber > maxValue) {
								newNumber = maxValue;
							}
						}
						break;
					case 'minus':
						newNumber = currentNumber - step;
						if(minValue !== undefined) {
							if(newNumber < minValue) {
								newNumber = minValue;
							}
						}
						break;
					default:
						break;
				}
				const nrOfDecimals = duo.Utils.countDecimals(step);
				newNumber = newNumber.toFixed(nrOfDecimals);
				$numberInput.val(newNumber);

				// trigger change event on number input:
                $numberInput.change();

				// check state:
				numberspinner._checkState($numberInput);
			});

			// number input change:
			// -> check if we need to disable the buttons (when min/max reached):
			$(document).find(`.${INPUT_CONTAINER_CLASS} ${numberspinner.inputSelector}`).on('input', function() {
				const $numberInput = $(this);
				numberspinner._checkState($numberInput);
			});

		} /* _setEventHandlers */

		/**
		 * Check state (button enabled/disabled and input value)
		 * when the number input changes
		 */
		_checkState($numberInput) {
			// get input-properties:
			// -> min:
			let minValue;
			const minAttributeValue = $numberInput.attr('min');
			if(duo.Utils.isNumber(minAttributeValue)) {
				minValue = parseFloat(minAttributeValue);
			}
			// -> max:
			let maxValue;
			const maxAttributeValue = $numberInput.attr('max');
			if(duo.Utils.isNumber(maxAttributeValue)) {
				maxValue = parseFloat(maxAttributeValue);
			}
			// -> input value:
			let currentNumber = 1;
			const inputValue = $numberInput.val();
			if(duo.Utils.isNumber(inputValue)) {
				currentNumber = parseFloat(inputValue);
			}

			// get the control-buttons + check if they should be enabled or disabled:
			const $spinnerContainer = $numberInput.parents(`.${CONTAINER_CLASS}`);
			if($spinnerContainer.length > 0) {
				const $plusButton = $spinnerContainer.find(`.${BUTTON_CLASS}[data-action="plus"]`);
				const $minusButton = $spinnerContainer.find(`.${BUTTON_CLASS}[data-action="minus"]`);

				$plusButton.removeAttr('disabled');
				$minusButton.removeAttr('disabled', '');

				if(currentNumber <= minValue) {
					$minusButton.attr('disabled', 'true');
				}

				if(currentNumber >= maxValue) {
					$plusButton.attr('disabled', '');
				}
			}

			// check number input:
			if(maxValue !== undefined) {
				if(currentNumber > maxValue) {
					$numberInput.val(maxValue);
				}
			}
			if(minValue !== undefined) {
				if(currentNumber < minValue) {
					$numberInput.val(minValue);
				}
			}
		} /* _checkState */

	} /* NumberSpinner */

	duo.NumberSpinner = NumberSpinner;

})(jQuery, window.duo = window.duo || {});
